import { RECEIVE_CAPITAL_GAINS_SUMMARY, REQUEST_CAPITAL_GAINS_SUMMARY } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_CAPITAL_GAINS_SUMMARY:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_CAPITAL_GAINS_SUMMARY: {
            return { ...state, ...data, isFetching: false }
        }

        default:
            return state
    }
}
